import React from 'react';
import CreateSmForm from './CreateSmForm';
import { Wrapper } from 'h-signup';

const SetupSm = () => (
	<Wrapper>
		<CreateSmForm />
	</Wrapper>
);

export default SetupSm;
